import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import TalentOpusRender from './TalentOpus.render';
import {useLazyQuery} from '@apollo/client';
import {query} from '../../../actions/queries';

export default function TalentOpusLoad():JSX.Element{
	const {id}:any = useParams();
	const [loading, setLoading] = useState<boolean>(true);
	// eslint-disable-next-line @typescript-eslint/typedef
	const [getAudience, { data }] = useLazyQuery(query('instagramAudienceFindOne'));

	useEffect(():void=>{
		if(loading){
			getAudience({
				variables: {
					filter: {
						user: id
					}
				},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => setLoading(false)
			});
		}
	},[loading]);


	return (
		<TalentOpusRender audience={data?.instagramAudienceFindOne} />
	);
}